// extracted by mini-css-extract-plugin
module.exports = {"heading":"employee-grid-module--heading--1-f_x","item":"employee-grid-module--item--29Ayf","list":"employee-grid-module--list--H-ej0"};